// LocationModel.ts
import * as Yup from 'yup'
import { TabOption } from '../../../../shared/components/FormTabHeader'
import { BaseEntity } from '../../../../shared/models/ApiModels'

export interface ILocationModel extends BaseEntity{ 
  name: string // zorunlu
  nameEnglish: string //zorunlu
  meetingPoint: string
  mailAddress: string // zorunlu
  phone: string //zorunlu
  iata?: string
  xmlServices?: boolean
  locationType?: 'BELIRSIZ' | 'BELIRLI'
  locationInfo?: boolean
  address?: string
  country: string //zorunlu
  mapsLocation?: string
  additionalDescription?: string
  displayOrder: number //zorunlu
  defaultBranch?: boolean
  mondayWorkingHoursStart?: string
  mondayWorkingHoursEnd?: string
  tuesdayWorkingHoursStart?: string
  tuesdayWorkingHoursEnd?: string
  wednesdayWorkingHoursStart?: string
  wednesdayWorkingHoursEnd?: string
  thursdayWorkingHoursStart?: string
  thursdayWorkingHoursEnd?: string
  fridayWorkingHoursStart?: string
  fridayWorkingHoursEnd?: string
  saturdayWorkingHoursStart?: string
  saturdayWorkingHoursEnd?: string
  sundayWorkingHoursStart?: string
  sundayWorkingHoursEnd?: string

  // Şube & Drop ayarları
  branchDropSettings?: IBranchDropSetting[]
  dropDistances?: IDropDistance[]
}

export const initialLocation: ILocationModel = {
  id: '',
  // ZORUNLU ALANLAR
  name: '',
  nameEnglish: '',
  mailAddress: '',
  phone: '',
  country: '1',
  displayOrder: 9999,

  // OPSİYONEL ALANLAR
  meetingPoint: '',
  iata: '',
  xmlServices: false,
  locationType: 'BELIRSIZ' as const,
  locationInfo: false,
  address: '',
  mapsLocation: '',
  additionalDescription: '',
  defaultBranch: false,

  // Çalışma saatleri
  mondayWorkingHoursStart: '08:00',
  mondayWorkingHoursEnd: '23:59',
  tuesdayWorkingHoursStart: '08:00',
  tuesdayWorkingHoursEnd: '23:59',
  wednesdayWorkingHoursStart: '08:00',
  wednesdayWorkingHoursEnd: '23:59',
  thursdayWorkingHoursStart: '08:00',
  thursdayWorkingHoursEnd: '23:59',
  fridayWorkingHoursStart: '08:00',
  fridayWorkingHoursEnd: '23:59',
  saturdayWorkingHoursStart: '08:00',
  saturdayWorkingHoursEnd: '23:59',
  sundayWorkingHoursStart: '08:00',
  sundayWorkingHoursEnd: '23:59',

  // Şube & Drop ayarları
  branchDropSettings: [],
  dropDistances: [],
}

export const validationLocation = Yup.object().shape({
  // ZORUNLU ALAN VALİDASYONLARI
  name: Yup.string()
    .required('Lokasyon adı zorunludur')
    .min(2, 'En az 2 karakter olmalıdır')
    .max(100, 'En fazla 100 karakter olabilir'),

  nameEnglish: Yup.string()
    .required('İngilizce lokasyon adı zorunludur')
    .min(2, 'En az 2 karakter olmalıdır')
    .max(100, 'En fazla 100 karakter olabilir'),

  mailAddress: Yup.string()
    .required('E-posta adresi zorunludur')
    .email('Geçerli bir e-posta formatı girin'),

  phone: Yup.string()
    .matches(/^[58]\d{9}$/, 'Geçerli bir cep telefonu girin (5XXXXXXXXX veya 8XXXXXXXXX)')
    .required('Telefon numarası zorunludur'),

  country: Yup.string().required('Ülke bilgisi zorunludur'),

  displayOrder: Yup.number()
    .required('Sıralama numarası zorunludur')
    .min(0, 'Negatif değer olamaz')
    .integer('Tam sayı olmalıdır'),

  // OPSİYONEL ALANLAR İÇİN EK VALİDASYONLAR
  iata: Yup.string().max(3, 'En fazla 3 karakter olabilir'),
})

export type LocationTab = 'form' | 'branchDrop' | 'fileArticle' | 'list'

export const tabOptions: TabOption<LocationTab>[] = [
  {key: 'form', title: 'Lokasyon Tanımlama', icon: 'bi bi-geo-alt'},
  {key: 'branchDrop', title: 'Şube & Drop Ayarları', icon: 'bi bi-stack'},
  {key: 'fileArticle', title: 'Dosya & Makale Ekle', icon: 'bi bi-file-earmark-text'},
  {key: 'list', title: 'Lokasyon Listesi', icon: 'bi bi-list'},
]

export const MEETING_POINTS = [
  {value: 'OFIS_TESLIM', label: 'Ofis Teslim'},
  {value: 'ADRES_TESLIM', label: 'Adres Teslim'},
  {value: 'HAVALIMANI_OFISI', label: 'Havalimanı Ofisi'},
  {value: 'HAVALIMANI_TESLIM', label: 'Havalimanı Teslim'}, 
  {value: 'SHUTTLE', label: 'Shuttle'}, 
  {value: 'HAVALIMANI_DISINDA', label: 'Havalimanı Dışında'},
  {value: 'LIMAN', label: 'Liman'}, 
] as const

export const KARSILAMA_TURU_OPTIONS = [
  {value: 'HAVALIMANI_OFISI', label: 'Havalimanı ofisi'},
  {value: 'KARSILAMA', label: 'Karşılama'},
  {value: 'OFIS_TESLIM', label: 'Ofis Teslim'},
  {value: 'SHUTTLE', label: 'Shuttle'},
  {value: 'HAVALIMANI_DISINDA', label: 'Havalimanı Dışında'},
  {value: 'LIMAN', label: 'Liman'},
  {value: 'ADRES_TESLIM', label: 'Adres Teslim'},
] as const

export const MESAI_SAATLERI_OPTIONS = [
  {value: 'LOKASYON', label: 'Lokasyon'},
  {value: 'SUBE', label: 'Şube'},
  {value: 'AYNI_GUN_SUBE', label: 'Aynı Gün Şube'},
] as const

export interface IBranchDropSetting {
  branchId: string
  branchName: string
  isExitBranch: boolean
  greetingType: string
  workingHoursType: string
  specialMail: string
  specialPhone: string
}

export interface IDropDistance {
  branchId: string
  branchName?: string
  pickupLocationId: string
  pickupLocationName: string
  returnLocationId: string
  returnLocationName: string
  dropFee: number
  dropFee2: number
  supplyDuration: number
  minRental: number
}
 
export const LOCATION_TYPE = [ 
  {value: '0', label: 'Belirsiz'},
  {value: '1', label: 'Havalimanı'},
  {value: '2', label: 'Liman'},
  {value: '3', label: 'Şehir Merkezi'},
  {value: '4', label: 'Tren İstasyonu'},
  {value: '5', label: 'Otobüs Garı'},
] as const

export const YES_OR_NO = [
  {value: '1', label: 'Evet'},
  {value: '0', label: 'Hayır'},
] as const

export const WORKING_TIMES = [
  {
    label: 'Pazartesi',
    startKey: 'mondayWorkingHoursStart',
    endKey: 'mondayWorkingHoursEnd',
  },
  {
    label: 'Salı',
    startKey: 'tuesdayWorkingHoursStart',
    endKey: 'tuesdayWorkingHoursEnd',
  },
  {
    label: 'Çarşamba',
    startKey: 'wednesdayWorkingHoursStart',
    endKey: 'wednesdayWorkingHoursEnd',
  },
  {
    label: 'Perşembe',
    startKey: 'thursdayWorkingHoursStart',
    endKey: 'thursdayWorkingHoursEnd',
  },
  {
    label: 'Cuma',
    startKey: 'fridayWorkingHoursStart',
    endKey: 'fridayWorkingHoursEnd',
  },
  {
    label: 'Cumartesi',
    startKey: 'saturdayWorkingHoursStart',
    endKey: 'saturdayWorkingHoursEnd',
  },
  {
    label: 'Pazar',
    startKey: 'sundayWorkingHoursStart',
    endKey: 'sundayWorkingHoursEnd',
  },
]

// "Lokasyon Drop Durumları" sayfası modelleri
export interface ILocationDropModel extends BaseEntity {
  branchName: string
  pickupLocationName: string
  returnLocationName: string
  dropFee: number
  minRental: number
  supplyDuration: number
}

export interface ILocationDropFilter {
  branchId?: string
  pickupLocationId?: string
  returnLocationId?: string
}

export const initialLocationDropFilter: ILocationDropFilter = {
  branchId: '',
  pickupLocationId: '',
  returnLocationId: '',
}
